import { apiGatewayHost } from './General';

export const getCategoryDescriptionApi = apiGatewayHost + '/product-data/v1/navigation-items/description?categoryName=';
